import { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserService } from "../../services";
import { useStore } from "../../store";
import CopyRight from "../../components/CopyRight";
import Logo from "../../components/Logo";
import ThemeToggle from "../../components/ThemeToggle";

function Activate() {
  const location = useLocation();
  const { setIsLoading } = useStore((s: any) => s);
  const [validationMessage, setValidationMessage] = useState<string>("");
  const [isActive, setIsActive] = useState(false);

  const handleActivateAccount = useCallback(async () => {
    setValidationMessage("");
    let token = location.search?.split("?token=")[1] || "";
    if (!token || token.length !== 24) {
      setValidationMessage(`Invalid account activation token.`);
      return;
    }

    setIsLoading(true);
    UserService.activateAccount({ userId: token }).then((result) => {
      if (result.error) {
        setValidationMessage(result.error);
        setIsLoading(false);
        return;
      }

      setIsLoading(false);
      setValidationMessage("");
      setIsActive(true);
    });
  }, [setIsLoading, location.search]);

  useEffect(() => {
    handleActivateAccount();
  }, [handleActivateAccount]);

  return (
    <div className="container">
      <div className="row h-100vh">
        <div className="col-md-5 loginLeft position-relative">
          <div className="d-flex align-items-center h-100 w-100">
            <div className="w-100">
              <div className="text-md-start text-center">
                <Link to="/">
                  <Logo width={100} height={100} />
                </Link>
              </div>
              <h1>Activate your account</h1>
              <p>
                Your account will be activated automatically based on the
                activation token provided in the link we sent in the email
              </p>
              <div className="formMain">
                {validationMessage && (
                  <div className="validation-message">{validationMessage}</div>
                )}
                {isActive && (
                  <div className="success-message">
                    Your account is activated successfully! Please login and
                    start using the application.{" "}
                    <Link to="/login">Login here</Link>
                  </div>
                )}
              </div>
              <div className="authThemeToggle mt-4">
                <ThemeToggle />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center registerMain gap-2">
            <span>New member?</span>
            <div className="d-flex gap-2">
              <Link to="/register">Register here</Link>
            </div>
          </div>
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-6 position-relative">
          <div className="d-md-flex align-items-center h-100 d-none">
            <img src="/assets/imgs/signin.png" className="w-100" alt="" />
          </div>
          <CopyRight />
        </div>
      </div>
    </div>
  );
}

export default Activate;
